enum ConsultationType {
  CONSULTATION = 'consultation',
  PURCHASE = 'purchase',
  POPUP = 'popup',
  DISCOUNT = 'discount',
  CARD = 'card',
}

enum PurchaseType {
  OMS = 'oms',
  EMPLOYER = 'employer',
}
interface IDopRequestValues {
  courseId?: number | null
  reason?: string
  typePurchase?: PurchaseType | null
  type?: ConsultationType
}

export { ConsultationType, PurchaseType }
export type { IDopRequestValues }
